import { HoldReaction, HoldRestrictionType, HoldTypeResponseDto } from '@planning/app/api'

export interface HoldTypeTableData {
  id: number
  name: string
  description?: string | null
  entryRestriction: HoldReaction | null
  exitRestriction: HoldReaction | null
  yardRestriction: HoldReaction | null
  isActive: boolean
  userRoles: number[]
  isDefault: boolean
}

export function mapToTableData(dto: HoldTypeResponseDto): HoldTypeTableData {
  const find = (type: HoldRestrictionType): HoldReaction | null =>
    dto.restrictions?.find(r => r.restrictionType === type)?.reaction ?? null

  return {
    id: dto.id,
    name: dto.name,
    description: dto.description,
    entryRestriction: find(HoldRestrictionType.Entry),
    exitRestriction: find(HoldRestrictionType.Exit),
    yardRestriction: find(HoldRestrictionType.Yard),
    isActive: dto.isActive,
    userRoles: dto.userRoles,
    isDefault: dto.isDefault,
  }
}
